﻿import React, { Fragment } from 'react';
import classNames from 'classnames';
import { RadioGroup, Radio } from "@blueprintjs/core";
import PropTypes from 'prop-types';
import { ShowHide } from 'components/layout';
import { FormHelperText } from "components/form-fields";
import { Tooltip } from "components/tooltip";
import 'components/form-fields/FormFields.css';

export function FormRadio(
    {
        id = null,
        options = [{ value: true, label: "Yes" }, { value: false, label: "No" }],
        loading = false,
        headingText = null,
        helperText = null,
        disabled = false,
        bordered = false,
        selectedValue = null,
        dangerHelperText = null,
        onChange
    }
) {
   
    return (
        <div className="form-field" id={id}>
            <ShowHide
                evaluator={headingText != null}
                show={(
                    <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
                )}
            />
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <RadioGroup
                className={classNames({ "form-radio-bordered": bordered })}
                disabled={disabled}
                onChange={onChange}
                selectedValue={selectedValue}
            >
                {options.map((option) => {
                    const radioElement = (
                        <Radio className={classNames({ "bp6-skeleton": loading })} onChange={onChange} checked={selectedValue === option.value} label={option.label} value={option.value} disabled={disabled || option.disabled} />
                    );
                    return (
                        <Fragment key={option.value}>
                            {option.tooltip != null
                                ? <Tooltip content={option.tooltip}>{radioElement}</Tooltip>
                                : radioElement}
                            <ShowHide
                                evaluator={selectedValue === option.value && option.onSelectRender != null}
                                show={option.onSelectRender}
                            />
                            <div className="form-field-radio-helper-container">
                                <FormHelperText loading={loading}>{option.helperText}</FormHelperText>
                            </div>
                        </Fragment>
                    );
                })}
            </RadioGroup>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormRadio.propTypes = {
    id: PropTypes.string,
    options: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    disabled: PropTypes.bool,
    bordered: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.any,
    dangerHelperText: PropTypes.node
};